module.exports = __webpack_public_path__ + "static/media/thank-you-decoration.a117e575.png";